export const SHORT_TEXT_LENGTH_LIMIT = 100;
export const MEDIUM_TEXT_LENGTH_LIMIT = 500;
export const LONG_TEXT_LENGTH_LIMIT = 1500;
export const XLONG_TEXT_LENGTH_LIMIT = 2000;
export const XXLONG_TEXT_LENGTH_LIMIT = 5000;
